/* import __COLOCATED_TEMPLATE__ from './step-block.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type AppService from 'embercom/services/app-service';
import type RouterService from '@ember/routing/router-service';

interface Args {
  number: number;
  title: string;
  description?: string;
  linkUrl: string;
  linkText: string;
  isLast?: boolean;
}

export default class StepBlock extends Component<Args> {
  @service declare appService: AppService;
  @service declare router: RouterService;

  @action
  navigateToLink(linkUrl: string) {
    if (linkUrl) {
      this.router.transitionTo(linkUrl, this.appService.app.id);
    }
  }

  @action
  handleKeydown(linkUrl: string, event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.navigateToLink(linkUrl);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::StepBlock': typeof StepBlock;
  }
}
